module.exports = __webpack_public_path__ + "static/media/icon_duorenwu.0351f626.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_duorenwu.svg
// module id = 126
// module chunks = 0